import React from 'react';
import { Trans } from 'react-i18next';
import { Flex, Text, Stack, Image, Box } from '@tonic-ui/react';
import cloudVideoThumbnailJpg from '../../../assets/landing/img/cloud-video-thumbnail.jpg';
import { PLExternalButtonLink } from '../tonic-ui-overrides';

const CloudVideoContent = (): JSX.Element => {
  return (
    <Flex justifyContent="center">
      <Box
        position="relative"
        maxWidth="1200px"
        width="100%"
        minHeight="490px"
        backgroundColor="black"
        borderRadius="24px"
        marginX={{ md: '10%', lg: 0 }}
      >
        <Stack flexDirection={{ sm: 'column', lg: 'row' }}>
          <Box flex="1" paddingX={{ sm: '10%', md: '78px' }}>
            <Image
              margin="0 auto"
              display="block"
              alt="Man and woman staring over documents"
              src={cloudVideoThumbnailJpg}
              // Set maximum size of image and ensure proper resizing of img when width or height is limited.
              maxWidth="100%"
              width={{ sm: '432px', lg: '432px' }}
              height="520px"
              transform="translate(0,-85px)"
              borderRadius="20px"
              objectFit="cover"
              objectPosition="-104px 0px"
            />
          </Box>
          <Box
            flex="1"
            color="white"
            paddingTop={{ lg: '91px' }}
            paddingX={{ sm: '10%', lg: '0' }}
            paddingRight={{ lg: '35px' }}
            paddingBottom="85px"
          >
            <Text
              as="h2"
              margin="0"
              marginBottom="22px"
              fontWeight="700"
              fontSize="36px"
              lineHeight="54px"
            >
              <Trans i18nKey="publicLandingPage.breakDownSilos" />
            </Text>
            <Text fontWeight="400" fonSize="16px" lineHeight="27px" marginBottom="12px">
              <Trans i18nKey="publicLandingPage.securelyMeetYourBusinessGoals" />
            </Text>
            <PLExternalButtonLink href="https://www.youtube.com/watch?v=oX5k5SXxnyw&t=20s">
              <Trans i18nKey="publicLandingPage.watchVideo" />
            </PLExternalButtonLink>
          </Box>
        </Stack>
      </Box>
    </Flex>
  );
};

CloudVideoContent.displayName = 'CloudVideoContent';

export default CloudVideoContent;
